module.exports = __webpack_public_path__ + "resources/images/handelsbanken-1e0cdf273c91a74ae77804496d420cab-cache.png";